import styled from 'styled-components';

export const Wrap = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 8vh auto;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;

    > h1 {
      width: 100%;
    }
  }
`;

export const InputWrap = styled.div`
  margin: 12px 0;
  width: 100%;

  > p {
    margin-bottom: 8px;
    font-weight: 700;
  }
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 32px;

  button + button {
    margin-left: 20px;
  }
`;

export const NoticeWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 32px;
  padding: 12px 0;
  background-color: #facfd6;
`;

export const Notice = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 32px;
  color: red;
  padding: 0 12px;
`;

export const Terms = styled.div`
  margin: 12px 0 32px;
  width: 100%;
  max-height: 80px;
  padding: 12px;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  color: #222222;
  border: 1px solid rgb(223, 223, 223);
  overflow-y: scroll;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 20px;
  background-color: #EEEEEE;
  margin-bottom: 20px;
  border-radius: 4px;

  &:after {
    content: '';
    display: block;
    width: ${({ step }) => step * 11.111}%;
    height: 100%;
    background-color: blue;
    border-radius: 4px;
  }
`;

export const QuestionWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > p {
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    margin-bottom: 8px;

    > span {
      margin-left: 4px;
      color: #3E26FD;
    }
  }

  & + div {
    margin-top: 32px;
  }
`;

export const RadioRow = styled.div`
  & + div {
    margin-top: 12px;
  }
`;

export const Img = styled.img`
  width: 88px;
  height: 88px;
  margin-bottom: 32px;
  object-fit: cover;
  font-family: 'object-fit: cover;';
`;
